import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const SendOtpApi = createAsyncThunk(
  'SendOtpApi',
  async (sendOtpPayload, { dispatch }) => {
    dispatch({ type: 'SendOtpApi/pending', payload: {} });
    const {
      customerId,
      Authorization,
      customerRefNum,
      txnAmount,
      templateType,
    } = sendOtpPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'esqa/sendotpexistingcustomer',
      payload: {
        customerRefNum,
        templateType,
        txnAmount,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const sendOtpRes = res;
        dispatch({
          type: 'SendOtpApi/fulfilled',
          payload: sendOtpRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'SendOtpApi/rejected', payload: err });
      },
    });
  }
);

export const SendOtpApi_extrareducer = {
  [SendOtpApi.pending]: (state, action) => {
    state.sendOtpApiState.isLoading = true;
  },
  [SendOtpApi.fulfilled]: (state, action) => {
    state.sendOtpApiState.isLoading = false;
    state.sendOtpApiState.isSuccess = true;
    state.sendOtpApiState.isError = false;
    state.sendOtpApiState.response = action.payload;
  },
  [SendOtpApi.rejected]: (state, action) => {
    state.sendOtpApiState.isLoading = false;
    state.sendOtpApiState.isSuccess = false;
    state.sendOtpApiState.isError = true;
    state.sendOtpApiState.response = action.payload;
  },
};
